import axios from 'axios';

// search roles api
export async function searchModuleAccessAPI(Data) {
	let moduleAccesslist = [];
	const moduleAccessCode = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/moduleAccess/search/?moduleAccessCode=${moduleAccessCode}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		moduleAccesslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleAccesslist;
}

// check existing role api
export async function getModuleAccessCodeAPI(Data) {
	let moduleAccesslist = [];
	const accessTypeName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/moduleAccess/getAccessTypeName/?accessTypeName=${accessTypeName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		moduleAccesslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleAccesslist;
}

//create module access api
export async function createModuleAccessAPI(Data, userID) {
	let moduleAccessData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/moduleAccess/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		moduleAccessData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleAccessData;
}

//update roles api
export async function updateModuleAccessAPI(Data, moduleAccessCode, userID) {
	let moduleAccessData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/moduleAccess/update/?moduleAccessCode=${moduleAccessCode}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		moduleAccessData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleAccessData;
}